var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ex-view-container" },
    [
      _c("kline", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showView === "kline",
            expression: "showView === 'kline'"
          }
        ],
        attrs: { toogleDepth: _vm.toogleDepth }
      }),
      _vm._v(" "),
      _vm.showView === "depth"
        ? _c("depth", { attrs: { toogleDepth: _vm.toogleDepth } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }